// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.insights_filters__e4lF2 {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  margin-bottom: var(--space-5);
}
.insights_filter__R8CIo {
  padding: 0.5rem 1rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-pill);
  background: var(--color-paper);
  font-family: var(--font-sans);
  cursor: pointer;
}
.insights_filter__R8CIo[aria-pressed="true"] {
  background: var(--color-ink);
  color: #fff;
  border-color: var(--color-ink);
}
.insights_grid__q9-gz {
  display: grid;
  gap: var(--space-5);
  grid-template-columns: repeat(auto-fit, minmax(min(16rem, 100%), 1fr));
}
.insights_card__mUj5j {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-6);
  background: var(--color-paper);
  border-radius: var(--radius-md);
}
.insights_featured__bxRBa {
  grid-column: 1 / -1;
}
.insights_meta__EoqTo {
  margin: 0;
  font-size: var(--text-caption);
  color: var(--color-text-muted);
}
.insights_title__qiE2f {
  margin: 0;
  font-size: var(--text-h3);
  font-weight: 500;
  line-height: var(--leading-heading);
}
.insights_title__qiE2f a {
  color: inherit;
  text-decoration: none;
}
.insights_title__qiE2f a::after {
  content: "";
  position: absolute;
  inset: 0;
}
.insights_excerpt__B7izz {
  margin: 0;
  color: var(--color-text-muted);
}
.insights_arrow__xHVsK {
  margin-top: auto;
  transition: transform var(--dur-fast) var(--ease-out);
}
.insights_card__mUj5j:hover .insights_arrow__xHVsK {
  transform: translateX(6px);
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/HOME_PAGE/SECTIONS/INSIGHTS/insights.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,oBAAoB;EACpB,qCAAqC;EACrC,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,4BAA4B;EAC5B,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sEAAsE;AACxE;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,8BAA8B;EAC9B,8BAA8B;AAChC;AACA;EACE,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,SAAS;EACT,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,qDAAqD;AACvD;AACA;EACE,0BAA0B;AAC5B","sourcesContent":[".filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-2);\n  margin-bottom: var(--space-5);\n}\n.filter {\n  padding: 0.5rem 1rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-pill);\n  background: var(--color-paper);\n  font-family: var(--font-sans);\n  cursor: pointer;\n}\n.filter[aria-pressed=\"true\"] {\n  background: var(--color-ink);\n  color: #fff;\n  border-color: var(--color-ink);\n}\n.grid {\n  display: grid;\n  gap: var(--space-5);\n  grid-template-columns: repeat(auto-fit, minmax(min(16rem, 100%), 1fr));\n}\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n  padding: var(--space-6);\n  background: var(--color-paper);\n  border-radius: var(--radius-md);\n}\n.featured {\n  grid-column: 1 / -1;\n}\n.meta {\n  margin: 0;\n  font-size: var(--text-caption);\n  color: var(--color-text-muted);\n}\n.title {\n  margin: 0;\n  font-size: var(--text-h3);\n  font-weight: 500;\n  line-height: var(--leading-heading);\n}\n.title a {\n  color: inherit;\n  text-decoration: none;\n}\n.title a::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n}\n.excerpt {\n  margin: 0;\n  color: var(--color-text-muted);\n}\n.arrow {\n  margin-top: auto;\n  transition: transform var(--dur-fast) var(--ease-out);\n}\n.card:hover .arrow {\n  transform: translateX(6px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filters": `insights_filters__e4lF2`,
	"filter": `insights_filter__R8CIo`,
	"grid": `insights_grid__q9-gz`,
	"card": `insights_card__mUj5j`,
	"featured": `insights_featured__bxRBa`,
	"meta": `insights_meta__EoqTo`,
	"title": `insights_title__qiE2f`,
	"excerpt": `insights_excerpt__B7izz`,
	"arrow": `insights_arrow__xHVsK`
};
export default ___CSS_LOADER_EXPORT___;
